'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _marketoForm = require('hellosign/components/marketo-form');

var _marketoForm2 = _interopRequireDefault(_marketoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_marketoForm2['default'], {
    formId: 1133
});

var SendExampleSignatureRequestForm = _baseForm2['default'].createFormClass({

    displayName: 'SendExampleSignatureRequestForm',

    propTypes: {
        'emailAddressOrPhoneNumber': _react2['default'].PropTypes.string
    },

    componentDidMount: function componentDidMount() {},

    getInitialState: function getInitialState() {
        return {
            'emailAddressOrPhoneNumber': this.props.emailAddressOrPhoneNumber
        };
    },

    onInputChange: function onInputChange(event) {
        this.setState({
            'emailAddressOrPhoneNumber': event.target.value.trim(),
            'errors': null,
            'hasErrors': false,
            'isProcessing': false,
            'isComplete': false
        });
    },

    render: function render() {

        var tabOffset = 0;

        var inputField = this.renderField('email_address_or_phone_number', {
            'tabIndex': tabOffset + 1,
            'className': 'm-api-example--input ' + (this.state.hasErrors ? 'has-error' : ''),
            'placeholder': 'Enter email or phone no.',
            'data-format': 'text',
            'onChange': this.onInputChange,
            'value': this.state.emailAddressOrPhoneNumber
        });

        var successConfirmation;
        if (this.state.isComplete) {
            successConfirmation = _jsx('div', {
                className: 'm-api-example--confirm l-margin-b-25'
            }, void 0, _jsx('span', {}, void 0, 'Example sent!'), _jsx('span', {}, void 0, 'Would you like to share it with anyone else?'));
        }

        var CTA = _jsx(_reactAddonsCssTransitionGroup2['default'], {
            transitionName: 'm-api-example--cta',
            transitionAppear: true,
            transitionAppearTimeout: 400
        }, void 0, _jsx('div', {
            className: 'm-api-example--cta'
        }, void 0, _jsx('p', {}, void 0, 'SEE OUR API IN ACTION'), _jsx('img', {
            src: require('./orange_arrow_@2x.png')
        })));

        var error = _jsx('div', {
            className: 'm-api-example--error'
        }, void 0, _jsx(_reactAddonsCssTransitionGroup2['default'], {
            transitionName: 'm-api-example--error',
            transitionEnterTimeout: 300,
            transitionLeaveTimeout: 300
        }, void 0, this.renderErrorText()));

        return _jsx('div', {
            className: 'm-api-example--marketo-container'
        }, void 0, _jsx(_reactAddonsCssTransitionGroup2['default'], {
            transitionName: 'm-api-example--confirm',
            transitionEnterTimeout: 300,
            transitionLeaveTimeout: 300
        }, void 0, successConfirmation), _jsx('div', {
            className: 'm-api-example--container row ' + (this.state.isProcessing || this.state.isComplete ? 'slide-down' : 'slide-up')
        }, void 0, _jsx('div', {
            className: 'small-12 large-4 columns'
        }, void 0, CTA), _jsx('div', {
            className: 'small-12 large-8 small-text-center large-text-left columns'
        }, void 0, _ref)));
    }
});

module.exports = SendExampleSignatureRequestForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/send-example-signature-request-form.jsx
 ** module id = 736
 ** module chunks = 0
 **/